import React, { FC } from 'react';
import useCiaData from '@components/EntityDrawers/components/CiaInputsGroup/hooks/useCiaData';
import CriteriaInput from '@components/EntityDrawers/components/ControlAssurance/CriteriaInput';
import useSameCheck from '@components/EntityDrawers/components/ControlAssurance/hooks/useSameCheck';
import ControlledCheckbox from '@components/Inputs/controllers/ControlledCheckbox';
import { useProject } from '@context/Project/ProjectProvider';
import { Stack } from '@mui/material';

type Props = {
  criteriaName: string;
  checkName: string;
  controlName: string;
};

const ControlAssurance: FC<Props> = ({
  criteriaName,
  checkName,
  controlName,
}) => {
  const { viewOnly } = useProject();
  const { isCiaActivated, questionnaire } = useCiaData();

  const { isSameChecked, handleSameChanged } = useSameCheck(
    checkName,
    criteriaName,
    controlName,
  );

  if (!isCiaActivated || !questionnaire) return null;

  return (
    <Stack gap={2}>
      <CriteriaInput
        name={criteriaName}
        isSame={isSameChecked}
        controlName={controlName}
        disabled={viewOnly}
      />

      <ControlledCheckbox
        label="same as entity Assurance"
        name={checkName}
        onChange={handleSameChanged}
        disabled={viewOnly}
      />
    </Stack>
  );
};

export default ControlAssurance;
